import React from 'react';
import { Typography } from '@material-ui/core';
import { coloresEmma } from '../../../../global/js/funciones';
import {
    DIAS_SEMANA,
    aHoraCompacta,
    normalizarDias,
} from '../helpers/horarioBienestarUtils';

/**
 * La semana en siete columnas.
 * Se comparte entre el panel de administración y el aviso de fuera de horario
 *
 * @param {Array}   dias          Días tal como llegan del backend.
 * @param {boolean} resaltarHoy   Marca la columna del día actual.
 * @param {boolean} compacto      Reduce el alto de las celdas.
 */
export default function SemanaHorario({ dias, resaltarHoy = true, compacto = false }) {
    const semana = normalizarDias(dias);
    const hoy = (new Date().getDay() + 6) % 7;

    return (
        <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(74px, 1fr))',
            gap: 6,
        }}>
            {DIAS_SEMANA.map(({ valor, corto }) => {
                const dia = semana[valor];
                const esHoy = resaltarHoy && valor === hoy;
                const cerrado = !dia.abierto || !dia.hora_inicio || !dia.hora_fin;
                return (
                    <div
                        key={valor}
                        style={{
                            textAlign: 'center',
                            padding: compacto ? '6px 3px 7px' : '9px 4px 10px',
                            borderRadius: 6,
                            border: `1px solid ${esHoy ? coloresEmma.primarycolor : '#ececec'}`,
                            backgroundColor: esHoy ? coloresEmma.serchover : '#fafafa',
                        }}
                    >
                        <Typography
                            variant="caption"
                            display="block"
                            style={{
                                fontWeight: 600,
                                letterSpacing: '.06em',
                                color: esHoy ? coloresEmma.primarycolor : '#9e9e9e',
                                marginBottom: compacto ? 2 : 4,
                            }}
                        >
                            {corto.toUpperCase()}
                        </Typography>
                        {cerrado ? (
                            <Typography
                                variant="caption"
                                display="block"
                                style={{ color: '#bdbdbd', fontStyle: 'italic', lineHeight: compacto ? 1.35 : 1.5 }}
                            >
                                Cerrado
                            </Typography>
                        ) : (
                            <>
                                <Typography
                                    variant="caption"
                                    display="block"
                                    style={{ color: '#424242', lineHeight: compacto ? 1.35 : 1.5, whiteSpace: 'nowrap' }}
                                >
                                    {aHoraCompacta(dia.hora_inicio)}
                                </Typography>
                                <Typography
                                    variant="caption"
                                    display="block"
                                    style={{ color: '#424242', lineHeight: compacto ? 1.35 : 1.5, whiteSpace: 'nowrap' }}
                                >
                                    {aHoraCompacta(dia.hora_fin)}
                                </Typography>
                            </>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
